import { render, staticRenderFns } from "./LabelDesigner.vue?vue&type=template&id=1584cbe7&scoped=true"
import script from "./LabelDesigner.vue?vue&type=script&lang=js"
export * from "./LabelDesigner.vue?vue&type=script&lang=js"
import style0 from "./LabelDesigner.vue?vue&type=style&index=0&id=1584cbe7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1584cbe7",
  null
  
)

export default component.exports